import DomainEntity from '@/models/DomainEntity'

export default class StrategySupplier extends DomainEntity {
  static get collectionName() {
    return 'strategysupplier/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      supplier: null,
    }
  }
}
